<template>
    <inline-tab-panel name="realworks">
        <flex-container style="padding-top:100px;">
            <flex-container justify-content="center" align-items="center">
                <flex-container :size="2">
                    <no-data-icon style="max-width: 100%;" />
                </flex-container>
                <flex-container :size="5" direction="column">
                    <text-heading>
                        Contact niet in Realworks
                    </text-heading>
                    <text-description>
                        Er kan geen Realworks informatie getoond worden van dit contact. Voeg het contact toe in Realworks om inzichten te krijgen.
                    </text-description>
                </flex-container>
            </flex-container>
        </flex-container>
    </inline-tab-panel>
</template>

<script setup lang="ts">
    import NoDataIcon from '@/assets/icons/undraw/no_data.svg?component';
    import type { ContactId } from '@keyvue/one-api-client';
    import { onMounted } from 'vue';

    const props = defineProps<{
        contactId: ContactId | null
    }>();

    onMounted(async () => {
        if (props.contactId) {
            // await RealworksAPI.getContactInformation(props.contactId.value);
        }
    });
</script>
